import { useMemo, useState } from "react";
import { BREAK_CATEGORIES, BREAKING_LIST } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

const badgeMap: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  猛: "bg-accent-500 text-foreground-950",
  热: "bg-secondary-100 text-secondary-900",
  新: "bg-secondary-200 text-secondary-900",
};

export default function Breaking() {
  const [cat, setCat] = useState("全部");
  const [kw, setKw] = useState("");

  const list = useMemo(() => {
    return BREAKING_LIST.filter((b) => {
      const okCat = cat === "全部" || b.category === cat;
      const okKw = !kw.trim() || b.title.includes(kw.trim()) || b.summary.includes(kw.trim());
      return okCat && okKw;
    });
  }, [cat, kw]);

  return (
    <section id="breaking" className="bg-background-50 py-14 md:py-20">
      <SectionHeader
        eyebrow="今日爆点 / BREAKING"
        title="今日爆点：那些正在炸开的瓜"
        desc="按下分类可快速筛选你关心的圈层，输入关键词即可在本站内实时搜索对应本月大瓜爆点与猛料线索。"
        accent
      />

      <div className="mx-auto mt-8 w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-100 p-3 sm:flex-row sm:items-center sm:justify-between sm:px-2 sm:py-2">
          <div className="flex flex-wrap items-center gap-1">
            {BREAK_CATEGORIES.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setCat(c)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${
                  cat === c
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="relative sm:w-72">
            <i className="ri-search-line pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-base text-foreground-500" />
            <input
              type="search"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="在本月大瓜内搜索关键词"
              className="w-full rounded-full border border-background-200 bg-background-50 py-2 pr-4 pl-9 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>
        </div>

        {list.length === 0 ? (
          <div className="mt-10 rounded-2xl border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
            <i className="ri-search-eye-line text-4xl text-secondary-400" />
            <p className="mt-3 text-sm text-foreground-600">暂无匹配的本月大瓜爆点，换个关键词试试吧。</p>
          </div>
        ) : (
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition hover:-translate-y-1 hover:border-primary-300"
              >
                <a href="#focus" className="relative block h-44 w-full overflow-hidden md:h-48" aria-label={`围观：${item.title}`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    title={`${item.title} - 本月大瓜爆点`}
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                  {item.badge && (
                    <span
                      className={`absolute top-3 left-3 rounded-md px-2 py-1 text-[11px] font-bold ${badgeMap[item.badge]}`}
                    >
                      {item.badge} · 爆点
                    </span>
                  )}
                  <span className="absolute right-3 bottom-3 rounded-md bg-background-950/60 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
                    {item.category}
                  </span>
                </a>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base leading-snug font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
                    <a href="#focus">{item.title}</a>
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" /> {item.reads}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" /> {item.comments}
                    </span>
                    <span>{item.time}</span>
                    <a
                      href="#focus"
                      className="inline-flex items-center gap-0.5 font-semibold text-primary-700 hover:text-primary-600"
                    >
                      围观 <i className="ri-arrow-right-up-line" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}